import React from "react";

import { Typography } from "@mui/material";

import styled from "@emotion/styled";

import { SystemData } from "globalTypes";
import { SidebarItemsType } from "types/sidebar";

import SidebarNavList from "./SidebarNavList";
import SidebarOptionSelect from "./SidebarOptionSelect";

const SidebarSelect = styled("div")`
  display: flex;
`;

type SidebarNavSectionProps = {
  className?: Element;
  component?: React.ElementType;
  pages: SidebarItemsType[];
  systemData: SystemData;
  title?: string;
  type?: string;
  isCollapsed?: boolean;
};

const Title = styled(Typography)`
  color: ${(props) => props.theme.sidebar.color};
  font-size: ${(props) => props.theme.typography.caption.fontSize};
  padding: ${(props) => props.theme.spacing(4)}
    ${(props) => props.theme.spacing(7)} ${(props) => props.theme.spacing(1)};
  opacity: 0.4;
  text-transform: uppercase;
  display: block;
`;

const SidebarNavSection: React.FC<SidebarNavSectionProps> = (props) => {
  const {
    title,
    pages,
    type,
    component: Component = "nav",
    systemData,
    isCollapsed = false,
    ...rest
  } = props;

  return (
    <Component {...rest}>
      {title && !isCollapsed && <Title variant="subtitle2">{title}</Title>}
      {!isCollapsed && (
        <SidebarSelect>
          {type && <SidebarOptionSelect type={type} systemData={systemData} />}
        </SidebarSelect>
      )}
      <SidebarNavList pages={pages} depth={0} isCollapsed={isCollapsed} />
    </Component>
  );
};

export default SidebarNavSection;
